var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LegalPage',{attrs:{"title":"Privacy Policy","subtitle":"Last updated: August 2026","intro":"This page explains how gbwhatsdroid.com handles information when you visit the site or contact us by email.","sections":_vm.sections,"email":"contact@gbwhatsdroid.com","page-name":"privacy"}})
}
var staticRenderFns = []

export { render, staticRenderFns }